<template>
  <div class="viewBoxGlobal">
    <div class="box">
      <div class="profile2Header">
        <div class="profilePicture" @click="showEditAvatar">
          <img class="level1" :src="Level1" />
          <div class="levelTextBox" :style="'background-image:url(' + LevelBox + ')'">
            <span class="levelText">{{$store.state.user?.user?.levelName}}</span>
          </div> 
          <img class="headPic" :src="HeaderPic" />
        </div>
        <div class="profile2HeaderItem buttonTransition">
          <svg width="56" height="46" viewBox="0 0 56 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.833374 6.50006C0.833374 3.18635 3.51967 0.500061 6.83337 0.500061H49.8334C53.1471 0.500061 55.8334 3.18635 55.8334 6.50006V11.4998H38.8339C33.311 11.4998 28.8339 15.977 28.8339 21.4998C28.8339 27.0227 33.311 31.4998 38.8339 31.4998H55.8334V39.5001C55.8334 42.8138 53.1471 45.5001 49.8334 45.5001H6.83337C3.51966 45.5001 0.833374 42.8138 0.833374 39.5001V6.50006Z" fill="white"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M38.8339 13.9998H55.8334V28.9998H38.8339C34.6917 28.9998 31.3339 25.642 31.3339 21.4998C31.3339 17.3577 34.6917 13.9998 38.8339 13.9998ZM39.3344 25.2501C41.4054 25.2501 43.0844 23.5712 43.0844 21.5001C43.0844 19.4291 41.4054 17.7501 39.3344 17.7501C37.2633 17.7501 35.5844 19.4291 35.5844 21.5001C35.5844 23.5712 37.2633 25.2501 39.3344 25.2501Z" fill="white"></path>
          </svg>
          <span>{{ $t("CentralWallet") }}</span>
        </div>
        <div class="profile2HeaderItem buttonTransition" @click="toWithdraw">
          <svg width="36" height="26" viewBox="0 0 56 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 19.0107C39.0092 18.4306 37.8886 17.1096 37.5903 15.5H18.2925C18.0021 17.0671 16.9322 18.3607 15.5 18.9632V27.0368C16.9322 27.6393 18.0021 28.9329 18.2925 30.5H37.5903C37.8886 28.8904 39.0092 27.5694 40.5 26.9893V19.0107ZM32.6875 23C32.6875 25.5888 30.5888 27.6875 28 27.6875C25.4112 27.6875 23.3125 25.5888 23.3125 23C23.3125 20.4112 25.4112 18.3125 28 18.3125C30.5888 18.3125 32.6875 20.4112 32.6875 23Z" fill="white"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5V14.581C4.07626 15.7083 6.66943 19.0513 6.66943 23C6.66943 26.9487 4.07626 30.2917 0.5 31.419V39.5C0.5 42.8137 3.18629 45.5 6.5 45.5H49.5C52.8137 45.5 55.5 42.8137 55.5 39.5V31.4666C51.8433 30.3886 49.1743 27.006 49.1743 23C49.1743 18.994 51.8433 15.6114 55.5 14.5334V6.5C55.5 3.18629 52.8137 0.5 49.5 0.5H6.5ZM24.3953 11.6719H40.4688L39.7304 8.3067L24.3953 11.6719ZM43 33H13V13H43V33Z" fill="white"></path>
          </svg>
          <span>{{ $t("WithdrawalDetails") }}</span>
        </div>
        <div class="profile2HeaderItem buttonTransition" @click="toDeposit">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.34473 3.00062V3.625L4.34473 3.625V3H20.6C21.9255 3 23 4.07452 23 5.4V6.3999H15.2002C13.5433 6.3999 12.2002 7.74305 12.2002 9.3999C12.2002 11.0568 13.5433 12.3999 15.2002 12.3999H23V18.6C23 19.9255 21.9255 21 20.6 21H4.34473V20.5H3.34473V20.9994C2.04477 20.97 1 19.907 1 18.6V5.4C1 4.09299 2.04477 3.03 3.34473 3.00062ZM3.34473 5.5V7.375H4.34473V5.5H3.34473ZM3.34473 9.25L3.34473 11.125H4.34473L4.34473 9.25H3.34473ZM3.34473 13V14.875H4.34473V13H3.34473ZM3.34473 16.75V18.625H4.34473V16.75H3.34473Z" fill="#FDD981"></path>
            <path d="M16.9004 9.3999C16.9004 10.2283 16.2288 10.8999 15.4004 10.8999C14.572 10.8999 13.9004 10.2283 13.9004 9.3999C13.9004 8.57148 14.572 7.8999 15.4004 7.8999C16.2288 7.8999 16.9004 8.57148 16.9004 9.3999Z" fill="#FDD981"></path>
          </svg>
          <span>{{ $t("DepositDetails") }}</span>
        </div>
      </div>
      <div class="profile2InfoBox">
        <div class="profile2InfoBoxTop">
          <div class="profile2InfoBoxTopLeft">
            <div style="display:flex;align-items: center;">
              {{ $t("ID") }}:{{$store.state.user?.user?.userId}}
              <svg
                :data-clipboard-text="$store.state.user?.user?.userId"
                :id="'id'+$store.state.user?.user?.userId"
                @click="copyID($store.state.user?.user?.userId)"
                style="width:2rem;height:2rem;margin-left:1rem"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      d="M753.312 698.848 753.312 383.6736c0-62.048-50.3104-112.3264-112.288-112.3264L395.3024 271.3472 324.288 271.3472l-53.7344 0-29.536 0c-62.048 0-112.288 50.272-112.288 112.3264l0 400.0512c0 61.9776 50.24 112.2752 112.288 112.2752l400.0128 0c62.048 0 112.288-50.2976 112.288-112.2752l0-31.0656 0.8768 0 0-54.0352C753.888 698.624 753.6768 698.7776 753.312 698.848zM660.6016 681.728l0 42.5984c0 0.864-0.2368 1.792-0.2368 2.6688-1.4272 42.3552-36.064 76.3008-78.7328 76.3008L300.3392 803.296c-43.5968 0-78.9056-35.3664-78.9056-78.9696L221.4336 442.9888c0-42.2336 33.2608-76.4928 75.0144-78.5984 1.2928-0.064 2.5984-0.3712 3.8912-0.3712l41.4272 0L581.632 364.0192c43.6608 0 78.9696 35.4048 78.9696 78.9696L660.6016 681.728zM895.1232 555.5008 895.1232 240.3264c0-62.048-50.3104-112.3264-112.288-112.3264L537.1136 128 466.0992 128l-53.7344 0-29.536 0c-62.048 0-112.288 50.272-112.288 112.3264l0 4.4736 115.0784 0c13.4912-13.8112 32.0256-22.72 52.6464-23.7568 1.2864-0.064 2.592-0.3712 3.8848-0.3712l41.4272 0 239.8656 0c43.6608 0 78.9696 35.4048 78.9696 78.9696l0 238.7328 0 42.5984c0 0.864-0.2368 1.792-0.2368 2.6688-0.8768 25.9136-14.208 48.6336-34.176 62.4l0 106.6048 14.8352 0c62.048 0 112.288-50.2976 112.288-112.2752l0-31.0656L896 609.3056l0-54.0352C895.6992 555.2768 895.488 555.424 895.1232 555.5008z"
                      fill="#64d656"
                  >
                  </path>
              </svg>
            </div>
            <div>{{ $t("Account") }}:{{ $store.state.user?.user?.userName }}</div>
          </div>
          <div class="profile2InfoBoxTopRight">
            <svg class="profile2InfoBoxSvg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M736 0 288 0c-52.8 0-96 43.2-96 96l0 832c0 52.8 43.2 96 96 96l448 0c52.8 0 96-43.2 96-96L832 96C832 43.2 788.8 0 736 0zM384 48l256 0 0 32L384 80 384 48zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64S547.346 960 512 960zM768 768 256 768 256 128l512 0L768 768z" fill="#000000"></path>
            </svg>
            <svg class="profile2InfoBoxSvg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M628.992 607.850667c-57.749333 46.272-93.781333 69.226667-129.728 69.226667-34.517333 0-69.376-21.504-123.285333-63.509333L55.082667 895.957333l903.701333 0L632.661333 605.098667C631.466667 605.973333 630.122667 607.061333 628.992 607.850667z" fill="#272636"></path>
              <path d="M248.405333 514.858667C172.224 456.106667 84.352 388.117333 0 321.429333L0 853.76c0 1.706667 0.810667 3.136 0.981333 4.714667l323.52-284.714667C301.056 555.456 275.904 536.106667 248.405333 514.858667z" fill="#272636"></path>
              <path d="M1021.482667 866.133333C1022.784 862.272 1024 858.218667 1024 853.76L1024 298.837333c-101.269333 78.762667-247.829333 192.917333-340.394667 265.962667L1021.482667 866.133333z" fill="#272636"></path>
              <path d="M960 128.021333 64 128.021333c-23.36 0-64 40.682667-64 64l0 50.432c94.378667 75.136 196.885333 154.218667 283.733333 221.205333 47.893333 36.970667 90.816 70.186667 124.693333 96.64 91.306667 71.616 91.306667 71.616 184.512-2.901333C677.226667 490.026667 904 313.557333 1024 220.224L1024 192.085333C1024 168.64 983.381333 128.021333 960 128.021333z" fill="#272636"></path>
            </svg>
            <div class="profile2InfoBoxTopRightRight">
              <div class="profile2InfoBoxTopRightRightButton" @click="toSetting">
                {{ $t("Change") }}
              </div>
              <svg
                @click="toSetting"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
                <path
                  d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                  fill="#8da5ca"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="profile2InfoBoxBottom">
          <div class="profile2InfoBoxBottomLeft">
            <div class="profile2InfoBoxBottomVipItem">
              <img :src="current.levelIcon" />
              <span>{{ current.levelName }}</span>
            </div>
            <IntoAnimate></IntoAnimate>
            <div class="profile2InfoBoxBottomVipItem">
              <img :src="next.levelIcon" />
              <span>{{ next.levelName }}</span>
            </div>
          </div>
          <div class="profile2InfoBoxBottomRight">
            <div class="profile2InfoBoxBottomRightLeft">
              <div class="profile2InfoBoxBottomRightLeftProcessItem">
                <div class="profile2InfoBoxBottomRightLeftProcessBox">
                  <div class="profile2InfoBoxBottomRightLeftProcessBoxText" :style="'width:' + ($store.state.user.user.totalRechargeAmount / next.payment * 100).toFixed(2) + '%' "></div>
                  <span>{{ $store.state.user.user.totalRechargeAmount }}/{{ next.payment }}</span>
                </div>
                <span>{{ $t("Deposit") }}</span>
              </div>
              <div class="profile2InfoBoxBottomRightLeftProcessItem">
                <div class="profile2InfoBoxBottomRightLeftProcessBox">
                  <div class="profile2InfoBoxBottomRightLeftProcessBoxText" :style="'width:' + ($store.state.user.user.totalBetAmount / next.gameStatement * 100).toFixed(2) + '%' "></div>
                  <span>{{ $store.state.user.user.totalBetAmount }}/{{ next.gameStatement }}</span>
                </div>
                <span>{{ $t("TotalBet") }}</span>
              </div>
            </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                @click="toVIP"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
          </div>
        </div>
      </div>
      <div class="profile2InfoMenu">
        <div class="profile2InfoMenuItem" @click="toAccount">
          <svg width="72" height="60" viewBox="0 0 72 60" fill="none" xmlns="http://www.w3.org/2000/svg"><g><g id="Union"><path d="M5.10791 6.11938C5.10791 4.04832 6.78684 2.36938 8.85791 2.36938H39.4579C41.529 2.36938 43.2079 4.04832 43.2079 6.11938C43.2079 8.19045 41.529 9.86938 39.4579 9.86938H8.85791C6.78684 9.86938 5.10791 8.19045 5.10791 6.11938Z" fill="#2FA33F"></path><path d="M5.10791 16.6194C5.10791 14.5483 6.78684 12.8694 8.85791 12.8694H39.4579C41.529 12.8694 43.2079 14.5483 43.2079 16.6194C43.2079 17.0758 43.1264 17.5131 42.9771 17.9177C40.9416 18.4708 39.0208 19.3026 37.2582 20.3694H8.85791C6.78684 20.3694 5.10791 18.6905 5.10791 16.6194Z" fill="#2FA33F"></path><path d="M30.0078 51.8694C28.5442 49.6155 27.4733 47.0832 26.8917 44.3694H8.85791C6.78684 44.3694 5.10791 46.0483 5.10791 48.1194C5.10791 50.1905 6.78684 51.8694 8.85791 51.8694H30.0078Z" fill="#2FA33F"></path><path d="M26.3921 39.6321C26.3921 37.6401 26.6509 35.7086 27.1368 33.8694H8.85791C6.78684 33.8694 5.10791 35.5483 5.10791 37.6194C5.10791 39.6905 6.78684 41.3694 8.85791 41.3694H26.4582C26.4144 40.796 26.3921 40.2167 26.3921 39.6321Z" fill="#2FA33F"></path><path d="M28.1622 30.8694C29.3673 28.0222 31.1418 25.4746 33.3429 23.3694H8.85791C6.78684 23.3694 5.10791 25.0483 5.10791 27.1194C5.10791 29.1905 6.78684 30.8694 8.85791 30.8694H28.1622Z" fill="#2FA33F"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M66.8921 39.6306C66.8921 49.5717 58.8332 57.6306 48.8921 57.6306C38.951 57.6306 30.8921 49.5717 30.8921 39.6306C30.8921 29.6895 38.951 21.6306 48.8921 21.6306C58.8332 21.6306 66.8921 29.6895 66.8921 39.6306ZM47.4584 44.4256C46.6549 45.1733 45.5776 45.6306 44.3936 45.6306C41.9083 45.6306 39.8936 43.6159 39.8936 41.1306C39.8936 38.3878 43.1221 35.6875 45.871 33.3885C47.074 32.3823 48.1851 31.453 48.8936 30.6306C49.4033 31.1403 50.1606 31.7844 51.0233 32.518C53.8806 34.9479 57.8936 38.3605 57.8936 41.1306C57.8936 43.6159 55.8788 45.6306 53.3936 45.6306C52.2613 45.6306 51.2268 45.2125 50.4359 44.5222C50.5764 45.6586 50.9884 46.3802 51.8936 47.1306V48.6306H45.8936V47.1306C46.8961 46.2005 47.3469 45.4398 47.4584 44.4256Z" fill="#2FA33F"></path></g></g></svg>
          <span>{{ $t("AccountDetails") }}</span>
        </div>
        <div class="profile2InfoMenuItem" @click="toDepositList">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.34473 3.00062V3.625L4.34473 3.625V3H20.6C21.9255 3 23 4.07452 23 5.4V6.3999H15.2002C13.5433 6.3999 12.2002 7.74305 12.2002 9.3999C12.2002 11.0568 13.5433 12.3999 15.2002 12.3999H23V18.6C23 19.9255 21.9255 21 20.6 21H4.34473V20.5H3.34473V20.9994C2.04477 20.97 1 19.907 1 18.6V5.4C1 4.09299 2.04477 3.03 3.34473 3.00062ZM3.34473 5.5V7.375H4.34473V5.5H3.34473ZM3.34473 9.25L3.34473 11.125H4.34473L4.34473 9.25H3.34473ZM3.34473 13V14.875H4.34473V13H3.34473ZM3.34473 16.75V18.625H4.34473V16.75H3.34473Z" fill="#FDD981"></path>
            <path d="M16.9004 9.3999C16.9004 10.2283 16.2288 10.8999 15.4004 10.8999C14.572 10.8999 13.9004 10.2283 13.9004 9.3999C13.9004 8.57148 14.572 7.8999 15.4004 7.8999C16.2288 7.8999 16.9004 8.57148 16.9004 9.3999Z" fill="#FDD981"></path>
          </svg>
          <span>{{ $t("DepositDetails") }}</span>
        </div>
        <div class="profile2InfoMenuItem" @click="toWithdrawal">
          <svg width="36" height="26" viewBox="0 0 56 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 19.0107C39.0092 18.4306 37.8886 17.1096 37.5903 15.5H18.2925C18.0021 17.0671 16.9322 18.3607 15.5 18.9632V27.0368C16.9322 27.6393 18.0021 28.9329 18.2925 30.5H37.5903C37.8886 28.8904 39.0092 27.5694 40.5 26.9893V19.0107ZM32.6875 23C32.6875 25.5888 30.5888 27.6875 28 27.6875C25.4112 27.6875 23.3125 25.5888 23.3125 23C23.3125 20.4112 25.4112 18.3125 28 18.3125C30.5888 18.3125 32.6875 20.4112 32.6875 23Z" fill="white"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5V14.581C4.07626 15.7083 6.66943 19.0513 6.66943 23C6.66943 26.9487 4.07626 30.2917 0.5 31.419V39.5C0.5 42.8137 3.18629 45.5 6.5 45.5H49.5C52.8137 45.5 55.5 42.8137 55.5 39.5V31.4666C51.8433 30.3886 49.1743 27.006 49.1743 23C49.1743 18.994 51.8433 15.6114 55.5 14.5334V6.5C55.5 3.18629 52.8137 0.5 49.5 0.5H6.5ZM24.3953 11.6719H40.4688L39.7304 8.3067L24.3953 11.6719ZM43 33H13V13H43V33Z" fill="white"></path>
          </svg>
          <span>{{ $t("WithdrawalDetails") }}</span>
        </div>
        <div class="profile2InfoMenuItem" @click="toBet">
          <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.60749 5.4845C7.60749 6.39818 6.86681 7.13886 5.95312 7.13886C5.03944 7.13886 4.29876 6.39818 4.29876 5.4845C4.29876 4.57082 5.03944 3.83013 5.95312 3.83013C6.86681 3.83013 7.60749 4.57082 7.60749 5.4845Z" fill="#FDD981"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.902 3.9822C18.6167 2.36583 17.2122 1.1875 15.5709 1.1875H5.17964C3.5383 1.1875 2.13382 2.36583 1.84858 3.9822L0.505521 11.5929C0.140005 13.6641 1.73332 15.5633 3.83658 15.5633H4.03737C5.57995 15.5633 6.92714 14.5196 7.31259 13.0259L7.6125 11.8638C7.80523 11.117 8.47882 10.5952 9.25011 10.5952H11.5004C12.2717 10.5952 12.9453 11.117 13.1381 11.8638L13.438 13.0259C13.6689 13.9208 14.245 14.6541 15.0014 15.0982C15.0008 15.0657 15.0005 15.0331 15.0005 15.0004C15.0005 12.2511 17.2194 10.0201 19.964 10.0005L18.902 3.9822ZM14.99 4.67564C15.4571 4.67564 15.8357 4.29704 15.8357 3.83001C15.8357 3.36298 15.4571 2.98438 14.99 2.98438C14.523 2.98438 14.1444 3.36298 14.1444 3.83001C14.1444 4.29704 14.523 4.67564 14.99 4.67564ZM14.99 8.05817C15.4571 8.05817 15.8357 7.67957 15.8357 7.21254C15.8357 6.74551 15.4571 6.36691 14.99 6.36691C14.523 6.36691 14.1444 6.74551 14.1444 7.21254C14.1444 7.67957 14.523 8.05817 14.99 8.05817ZM14.1444 5.52127C14.1444 5.9883 13.7658 6.36691 13.2988 6.36691C12.8317 6.36691 12.4531 5.9883 12.4531 5.52127C12.4531 5.05424 12.8317 4.67564 13.2988 4.67564C13.7658 4.67564 14.1444 5.05424 14.1444 5.52127ZM16.6813 6.36691C17.1483 6.36691 17.5269 5.9883 17.5269 5.52127C17.5269 5.05424 17.1483 4.67564 16.6813 4.67564C16.2143 4.67564 15.8357 5.05424 15.8357 5.52127C15.8357 5.9883 16.2143 6.36691 16.6813 6.36691ZM8.45312 5.4845C8.45312 6.86521 7.33384 7.9845 5.95312 7.9845C4.57241 7.9845 3.45312 6.86521 3.45312 5.4845C3.45312 4.10379 4.57241 2.9845 5.95312 2.9845C7.33384 2.9845 8.45312 4.10379 8.45312 5.4845Z" fill="#FDD981"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.0005 14.9004C24.0005 17.1095 22.2096 18.9004 20.0005 18.9004C17.7913 18.9004 16.0005 17.1095 16.0005 14.9004C16.0005 12.6913 17.7913 10.9004 20.0005 10.9004C22.2096 10.9004 24.0005 12.6913 24.0005 14.9004ZM19.682 15.9659C19.5034 16.1321 19.264 16.2337 19.0009 16.2337C18.4486 16.2337 18.0009 15.786 18.0009 15.2337C18.0009 14.6242 18.7183 14.0241 19.3292 13.5132C19.5965 13.2897 19.8435 13.0831 20.0009 12.9004C20.1142 13.0137 20.2825 13.1568 20.4742 13.3198C21.1091 13.8598 22.0009 14.6181 22.0009 15.2337C22.0009 15.786 21.5532 16.2337 21.0009 16.2337C20.7493 16.2337 20.5194 16.1408 20.3436 15.9874C20.3749 16.2399 20.4664 16.4003 20.6676 16.567V16.9004H19.3342V16.567C19.557 16.3604 19.6572 16.1913 19.682 15.9659Z" fill="#FDD981"></path></svg>
          <span>{{ $t("BetDetails") }}</span>
        </div>
        <div class="profile2InfoMenuItem" @click="toBonus">
          <svg class="tabbar_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200"><path d="M474.18097 127.290893l-134.35708 0q-13.933327 0-21.397609-6.469045t-10.449995-16.421421-2.985713-22.392847 1.990475-23.388084q0.995238-10.947614 3.980951-23.885703t8.45952-21.895228 14.430946-11.942852 21.895228 4.976188q14.928564 8.957139 33.83808 19.407134t36.823792 20.89999 33.340461 18.909515 23.388084 13.435708q9.952376 6.966663 14.928564 15.426183t3.980951 15.923802-7.961901 12.44047-19.904753 4.976188zM551.809505 126.295656l133.361843 0q13.933327 0 21.397609-6.469045t10.449995-16.421421 2.985713-22.392847-0.995238-23.388084q-1.990475-10.947614-4.478569-23.388084t-7.961901-21.397609-14.430946-11.942852-21.895228 3.980951q-14.928564 8.957139-33.83808 19.407134t-37.321411 20.89999-33.83808 18.909515-22.392847 13.435708q-10.947614 6.966663-15.923802 15.426183t-3.980951 15.923802 7.961901 12.44047 20.89999 4.976188zM460.247643 191.981339l-288.618913 0q-31.847604 0-41.302362 10.449995t-9.454758 33.340461l0 87.580912q0 24.880941 10.449995 36.823792t41.302362 11.942852l287.623676 0 0-180.138011zM568.728545 191.981339l284.637963 0q31.847604 0 43.292837 12.44047t11.445233 35.330936l0 85.590436q0 23.885703-10.449995 35.330936t-41.302362 11.445233l-287.623676 0 0-180.138011zM460.247643 424.866945l-305.537953 0 0 163.218972 0 64.690446 0 60.709496 0 51.752357 0 35.828555q0 50.757119 28.861891 78.623773t89.571387 27.866654l187.104675 0 0-482.690252zM568.728545 424.866945l304.542716 0 0 373.214112q-0.995238 50.757119-28.861891 80.116629t-88.576149 29.35951l-187.104675 0 0-482.690252z"></path></svg>
          <span>{{ $t("BonusDetails") }}</span>
        </div>
      </div>
      <div class="profile2RouteList">
        <div class="profile2RouteListItem buttonTransition" @click="toShare">
          <div class="profile2RouteListItemLeft">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.79961 4.2499C4.05403 4.2499 3.44961 4.85432 3.44961 5.59991V19.3999C3.44961 20.1455 4.05402 20.7499 4.79961 20.7499H19.1996C19.9452 20.7499 20.5496 20.1455 20.5496 19.3999V13.0999C20.5496 12.52 21.0197 12.0499 21.5996 12.0499C22.1795 12.0499 22.6496 12.52 22.6496 13.0999V19.3999C22.6496 21.3053 21.105 22.8499 19.1996 22.8499H4.79961C2.89422 22.8499 1.34961 21.3053 1.34961 19.3999V5.59991C1.34961 3.69452 2.89423 2.1499 4.79961 2.1499H12.5996C13.1795 2.1499 13.6496 2.62 13.6496 3.1999C13.6496 3.7798 13.1795 4.2499 12.5996 4.2499H4.79961ZM16.9571 3.05746C17.3672 2.64741 18.032 2.64741 18.4421 3.05746L21.1256 5.74096C21.2004 5.74404 21.2756 5.74742 21.351 5.75111L21.3409 5.95632L21.742 6.35744C22.1521 6.76749 22.1521 7.43231 21.742 7.84237L18.7045 10.8798C18.2945 11.2899 17.6297 11.2899 17.2196 10.8798C16.8096 10.4698 16.8096 9.80497 17.2196 9.39492L18.7563 7.85823C16.5883 7.99809 14.9131 8.50246 13.7166 9.33342C12.1629 10.4124 11.2496 12.1615 11.2496 14.8998C11.2496 15.4797 10.7795 15.9498 10.1996 15.9498C9.61971 15.9498 9.14961 15.4797 9.14961 14.8998C9.14961 11.6382 10.277 9.16547 12.5187 7.60859C14.0286 6.55993 15.961 5.98691 18.2084 5.79368L16.9571 4.54239C16.5471 4.13234 16.5471 3.46751 16.9571 3.05746Z" fill="#5378BF"></path></svg>
            <span>{{ $t("Agent") }}</span>
          </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
        </div>
        <div class="profile2RouteListItem buttonTransition" @click="toSetting">
          <div class="profile2RouteListItemLeft">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.7573 3.49878C8.8134 3.49878 7.23754 5.07463 7.23754 7.01855C7.23754 8.96246 8.8134 10.5383 10.7573 10.5383C12.7012 10.5383 14.2771 8.96246 14.2771 7.01855C14.2771 5.07463 12.7012 3.49878 10.7573 3.49878ZM5.73754 7.01855C5.73754 4.24621 7.98497 1.99878 10.7573 1.99878C13.5296 1.99878 15.7771 4.24621 15.7771 7.01855C15.7771 9.54963 13.9038 11.6432 11.468 11.9884C12.4043 12.0593 13.3028 12.2692 14.1422 12.5978C14.5279 12.7487 14.7182 13.1838 14.5672 13.5695C14.4163 13.9553 13.9812 14.1455 13.5955 13.9946C12.717 13.6507 11.7602 13.4616 10.7573 13.4616C6.70827 13.4616 3.38078 16.5509 3.00341 20.5011H14.8688C15.2831 20.5011 15.6188 20.8369 15.6188 21.2511C15.6188 21.6653 15.2831 22.0011 14.8688 22.0011H2.21777H1.46777V21.2511C1.46777 16.3598 5.2481 12.3515 10.0464 11.9884C7.61075 11.6431 5.73754 9.54957 5.73754 7.01855ZM20.6939 12.9167C20.096 12.5716 19.3315 12.7764 18.9863 13.3743L16.1617 18.2667L16.3306 21.8742L19.5392 20.2167L22.3638 15.3243C22.709 14.7264 22.5042 13.9619 21.9063 13.6167L20.6939 12.9167ZM17.6806 18.6359L20.1604 14.3408L20.9398 14.7908L18.46 19.0859L17.7196 19.4684L17.6806 18.6359Z" fill="#5378BF"></path></svg>
            <span>{{ $t("PersonalInformation") }}</span>
          </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
        </div>
        <div class="profile2RouteListItem buttonTransition" @click="toService">
          <div class="profile2RouteListItemLeft">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75309 10.1827C3.87691 5.73454 7.52171 2.16663 11.9998 2.16663C16.478 2.16663 20.1228 5.73454 20.2466 10.1827C21.4491 10.5104 22.3332 11.6103 22.3332 12.9166V14.1666C22.3332 15.4718 21.4507 16.5708 20.2498 16.8996V18.25L16.9998 18.25C15.6652 18.25 14.5832 17.168 14.5832 15.8333V12.0833C14.5832 10.7486 15.6651 9.66663 16.9998 9.66663H18.7086C18.3356 6.29166 15.4743 3.66663 11.9998 3.66663C8.52542 3.66663 5.66412 6.29166 5.29103 9.66663H6.99984C8.33452 9.66663 9.4165 10.7486 9.4165 12.0833V15.8333C9.4165 17.168 8.33453 18.25 6.99984 18.25H6.70112C7.0695 19.0843 7.90416 19.6666 8.87484 19.6666H9.63818C9.91763 18.9823 10.5899 18.5 11.3748 18.5H12.6248C13.6603 18.5 14.4998 19.3395 14.4998 20.375C14.4998 21.4105 13.6603 22.25 12.6248 22.25H11.3748C10.6221 22.25 9.97302 21.8065 9.67457 21.1666H8.87484C7.06551 21.1666 5.54581 19.9266 5.11926 18.25H3.74984V16.8996C2.549 16.5708 1.6665 15.4718 1.6665 14.1666V12.9166C1.6665 11.6103 2.55059 10.5104 3.75309 10.1827ZM20.2498 15.2692V11.8141C20.602 12.0541 20.8332 12.4583 20.8332 12.9166V14.1666C20.8332 14.6249 20.602 15.0292 20.2498 15.2692ZM3.74984 11.8141C3.39771 12.0541 3.1665 12.4583 3.1665 12.9166V14.1666C3.1665 14.6249 3.39771 15.0292 3.74984 15.2692V11.8141ZM18.7498 11.1666V16.75H16.9998C16.4936 16.75 16.0832 16.3396 16.0832 15.8333V12.0833C16.0832 11.577 16.4936 11.1666 16.9998 11.1666H18.7498ZM5.24984 16.75H6.99984C7.5061 16.75 7.9165 16.3396 7.9165 15.8333V12.0833C7.9165 11.577 7.5061 11.1666 6.99984 11.1666H5.24984V16.75Z" fill="#EAB700"></path></svg>
            <span>{{ $t("Support") }}</span>
          </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
        </div>
        <div class="profile2RouteListItem buttonTransition" @click="toDownload">
          <div class="profile2RouteListItemLeft">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_342047)"><path d="M7.46967 13.067C7.17678 13.3599 7.17678 13.8347 7.46967 14.1276L11.0252 17.6832C11.5636 18.2215 12.4364 18.2215 12.9748 17.6832L16.5303 14.1276C16.8232 13.8347 16.8232 13.3599 16.5303 13.067C16.2374 12.7741 15.7626 12.7741 15.4697 13.067L12.75 15.7866L12.75 6.66309C12.75 6.24887 12.4142 5.91309 12 5.91309C11.5858 5.91309 11.25 6.24887 11.25 6.66309L11.25 15.7866L8.53033 13.067C8.23744 12.7741 7.76256 12.7741 7.46967 13.067Z" fill="#FFD205"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z" fill="#FFD205"></path></g><defs><clipPath id="clip0_1_342047"><rect width="26" height="26" fill="white"></rect></clipPath></defs></svg>
            <span>{{ $t("DownloadApplication") }}</span>
          </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
        </div>
        <div class="profile2RouteListItem buttonTransition" @click="logout">
          <div class="profile2RouteListItemLeft profile2RouteListItemLeftSpecial">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.0166 6.4C5.0166 5.48873 5.75533 4.75 6.6666 4.75H16.8666C17.7779 4.75 18.5166 5.48873 18.5166 6.4V7.19971C18.5166 7.61392 18.8524 7.94971 19.2666 7.94971C19.6808 7.94971 20.0166 7.61392 20.0166 7.19971V6.4C20.0166 4.6603 18.6063 3.25 16.8666 3.25H6.6666C4.9269 3.25 3.5166 4.6603 3.5166 6.4V17.6C3.5166 19.3397 4.9269 20.75 6.6666 20.75H16.8666C18.6063 20.75 20.0166 19.3397 20.0166 17.6V16.1997C20.0166 15.7855 19.6808 15.4497 19.2666 15.4497C18.8524 15.4497 18.5166 15.7855 18.5166 16.1997V17.6C18.5166 18.5113 17.7779 19.25 16.8666 19.25H6.6666C5.75533 19.25 5.0166 18.5113 5.0166 17.6V6.4Z" fill="#E94D3E"></path><path d="M16.6647 8.75483C16.9576 8.46193 17.4325 8.46193 17.7254 8.75483L20.1389 11.1683C20.5984 11.6278 20.5984 12.3728 20.1389 12.8323L17.7254 15.2458C17.4325 15.5387 16.9576 15.5387 16.6647 15.2458C16.3718 14.9529 16.3718 14.4781 16.6647 14.1852L18.0996 12.7503H10.0166C9.60239 12.7503 9.2666 12.4145 9.2666 12.0003C9.2666 11.5861 9.60239 11.2503 10.0166 11.2503H18.0996L16.6647 9.81549C16.3718 9.52259 16.3718 9.04772 16.6647 8.75483Z" fill="#E94D3E"></path></svg>
            <span>{{ $t("Logout") }}</span>
          </div>
            <svg
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
              >
              <path
                d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z"
                fill="#8da5ca"
              ></path>
            </svg>
        </div>
      </div>
    </div>
    <Modal :visible.sync="editAvatarVisible">
      <div class="avatarBox">
        <div class="bonusTitle" style="margin-top: 2rem">
          <span>{{ $t("ChangeAvatar") }}</span>
        </div>
        <div class="avatarList">
          <div
            class="avatarItem"
            @click="changeAvatar(index)"
            v-for="(item, index) in editAvatarList"
            :key="index"
          >
            <img
              :src="item.avatar"
              :style="item.active ? '' : 'filter: grayscale(100%);'"
            />
            <div class="activeDesign" v-if="item.active">
              <div class="activeRight">
                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                  <path d="M442.88 1010.176c-147.968-183.296-322.048-322.048-442.88-365.568l286.72-172.032 138.24 268.8S650.24 195.584 1006.08 13.824C998.4 143.872 963.072 256.512 1024 395.264c-156.16 35.328-476.672 424.96-581.12 614.912z" fill="#ffffff"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="entryButton buttonTransition" @click="editAvatarVisible = false">{{ $t("OK") }}</div>
      </div>
    </Modal>
  </div>
</template>

<script>

import Modal from "../components/Modal.vue";
import IntoAnimate from "@/components/IntoAnimate.vue";

import Phone from "../assets/img/phone.png";
import Email from "../assets/img/email.png";
import Level1 from "../assets/img/level1.png";
import LevelBox from "../assets/img/levelBox.png";

import Head1 from "@/assets/simplewheel/1.png";
import Head2 from "@/assets/simplewheel/2.png";
import Head3 from "@/assets/simplewheel/3.png";
import Head4 from "@/assets/simplewheel/4.png";
import Head5 from "@/assets/simplewheel/5.png";
import Head6 from "@/assets/simplewheel/6.png";
import Head7 from "@/assets/simplewheel/7.png";
import Head8 from "@/assets/simplewheel/8.png";
import Head9 from "@/assets/simplewheel/9.png";
import Head10 from "@/assets/simplewheel/10.png";
import Head11 from "@/assets/simplewheel/11.png";
import Head12 from "@/assets/simplewheel/12.png";

const imageMap = {
  1: require('@/assets/simplewheel/1.png'),
  2: require('@/assets/simplewheel/2.png'),
  3: require('@/assets/simplewheel/3.png'),
  4: require('@/assets/simplewheel/4.png'),
  5: require('@/assets/simplewheel/5.png'),
  6: require('@/assets/simplewheel/6.png'),
  7: require('@/assets/simplewheel/7.png'),
  8: require('@/assets/simplewheel/8.png'),
  9: require('@/assets/simplewheel/9.png'),
  10: require('@/assets/simplewheel/10.png'),
  11: require('@/assets/simplewheel/11.png'),
  12: require('@/assets/simplewheel/12.png'),
  // 添加更多映射
};
// 根据avatar获取图片
const getAvatarImage = (avatar) => imageMap[avatar] || imageMap[1];

import { mapState } from 'vuex';
import Clipboard from "clipboard";

export default {
  name: "Mine",
  computed:{
    HeaderPic() {
      return getAvatarImage(this.$store.state.user.avatar);
    },
    ...mapState({
      user: state => state.user.user,
      vipList: state => state.user.vipList,
    }),
    current(){
      return this.vipList.find(item => item.level == this.user.level);
    },
    next(){
      return this.vipList.find(item => item.level == this.user.level+1) || this.vipList.find(item => item.level == this.user.level);
    }
  },
  data() {
    return {
      Phone, // 手机图标
      Email, // 邮件图标
      Level1, // 等级容器
      LevelBox, // 等级文本容器
      editAvatarList: [ // 头像选择列表
        {
          avatar: Head1,
          active: true,
        },
        {
          avatar: Head2,
          active: false,
        },
        {
          avatar: Head3,
          active: false,
        },
        {
          avatar: Head4,
          active: false,
        },
        {
          avatar: Head5,
          active: false,
        },
        {
          avatar: Head6,
          active: false,
        },
        {
          avatar: Head7,
          active: false,
        },
        {
          avatar: Head8,
          active: false,
        },
        {
          avatar: Head9,
          active: false,
        },
        {
          avatar: Head10,
          active: false,
        },
        {
          avatar: Head11,
          active: false,
        },
        {
          avatar: Head12,
          active: false,
        },
      ],

      editAvatarVisible: false, // 修改头像弹窗显示
    };
  },
  components: {
    Modal,
    IntoAnimate
  },
  methods: {
    toDownload(){
      const link = document.createElement('a');
      link.href = '/app.apk';  // 指向 public 文件夹中的 app.apk
      link.download = 'ckgames.apk';  // 设置下载的文件名
      link.click();  // 模拟点击下载
    },  
    copyID(id) {
      this.$message.info(this.$t("CopySuccess"));
      new Clipboard("#id" + id);
    },
    toAccount(){
      this.$router.push({
        path:"report",
        query:{type:"account"}
      })
    },
    toWithdrawal(){
      this.$router.push({
        path:"report",
        query:{type:"withdraw"}
      })
    },
    changeAvatar(index) { // 改变头像
      this.editAvatarList.forEach((item, index2) => {
        if (index === index2) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },
    showEditAvatar() { // 显示改变头像弹窗
      this.editAvatarVisible = true;
    },
    toDepositList(){
      this.$router.push({
        path:"report",
      })
    },
    toBonus(){
      this.$router.push({
        path:"report",
        query:{type:"bonus"}
      })
    },
    toBet(){
      this.$router.push({
        path:"report",
        query:{type:"bets"}
      })
    },
    toShare(){
      this.$router.push("/refer/invite")
    },
    toSetting(){
      this.$router.push("/setting")
    },
    toService(){
      this.$router.push("/service")
    },
    logout(){ // 退出
      this.$store.dispatch('LogOut').then(() => {
        this.profileOpen = false;
        this.$router.push("/home");
      })
    },
    toVIP() { // 跳转到vip页
      this.$router.push("/VIP");
    },
    toWithdraw(){ // 跳转到提现页
      this.$router.push({
        path: "/deposit",
      });
    },
    toDeposit() { // 跳转到充值页
      this.$router.push({
        path: "/deposit",
        query: {
          mode: "deposit",
        },
      });
    },
  },
  mounted() {
  },
};
</script>

<style scoped>

  .bonusTitle > svg {
    width: 2rem;
    height: 2rem;
  }
  .bonusTitle > span {
    color:var(--basic);
    font-size: 2rem;
    font-weight: bold;
  }
  .bonusTitle {
    display: flex;
    justify-content: space-between;
  }

  .profile2RouteListItemLeftSpecial path{
    fill:var(--error) !important;
  }

  .profile2InfoBoxBottomRightLeftProcessItem > span {
    margin-right:1rem;
  }

  .profile2InfoBoxBottomRightLeftProcessBox{
    width:15rem;
    height:2rem;
    background:var(--subbackground);
    border-radius:0.5rem;
    color:var(--basic);
    font-size:1.2rem;
    text-align: left;
    line-height:2rem;
    position:relative;
    overflow:hidden;
  }

  .profile2InfoBoxBottomRightLeftProcessBox span {
    position:relative;
    z-index:1;
    margin-lefT:0.5rem;
  }
  
  .profile2InfoBoxBottomRightLeftProcessBoxText{
    position:absolute;
    top:0;
    left:0;
    background:var(--gdient2);
    border-radius:0.5rem;
    height:100%;
  }

  .profile2InfoBoxBottomRightLeftProcessItem:nth-child(1){
    margin-bottom:1rem;
  }

  .profile2InfoBoxBottomRightLeftProcessItem{
    display:flex;
    color:var(--basic);
    font-size:1.2rem;
    font-weight:bold;
    text-align:right;
    flex-direction: row-reverse;
  }

  .profile2InfoBoxBottomRightLeft{
    display:flex;
    flex-direction: column;
    margin-right:1rem;
  }

  .profile2InfoBoxBottomRight > svg > path {
    fill:var(--subfont);
  }

  .profile2InfoBoxBottomRight > svg {
    width:1.5rem;
    height:1.5rem;
  }

  .profile2InfoBoxBottomRight{
    display:flex;
    align-items: center;
  }

  .profile2InfoBoxBottomVipSpec{
    margin-left:0.3rem;
    margin-right:0.3rem;
  }

  .profile2InfoBoxBottomVipItem > span {
    color:var(--basic);
    font-weight:bold;
    font-size:1.2rem;
  }

  .profile2InfoBoxBottomVipItem > img {
    height:5rem;
  }

  .profile2InfoBoxBottomVipItem{
    display:flex;
    flex-direction: column;
    align-items: center;
  }

  .profile2InfoBoxBottomLeft{
    display:flex;
    align-items: center;
  }

  .profile2InfoBoxBottom{
    display:flex;
    justify-content: space-between;
    align-items: center;
    margin-top:1rem;
  }

  .profile2RouteListItem > svg {
    width:1.5rem;
    height:1.5rem;
  }
  .profile2RouteListItem > svg > path{
    fill:var(--subfont);
  }

  .profile2RouteListItemLeft > span {
    margin-left:1rem;
    font-size:1.5rem;
  }

  .profile2InfoBoxSvg{
    height:2.5rem !important;
    width:3rem !important;
    margin-right:1.2rem;
  }

  .profile2RouteListItemLeft path {
    fill:var(--icon);
  }

  .profile2RouteListItemLeft > svg {
    width:3rem;
    height:3rem;
  }

  .profile2RouteListItemLeft{
    display:flex;
    align-items: center;
    color:var(--basic);
    font-size:1.2rem;
    font-weight:bold;
  }

  .profile2RouteListItem:last-child{
    margin-bottom:0;
  }

  .profile2RouteListItem{
    margin-bottom:1.3rem;
    display:flex;
    box-sizing:border-box;
    padding-bottom:1.3rem;
    justify-content: space-between;
    align-items: center;
    border-bottom:0.05rem solid var(--background);
  }

  .profile2RouteList{
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    width:100%;
    background:var(--primary);
    border-radius:0.5rem;
    box-sizing:border-box;
    padding:1.5rem;
    margin-top:1rem;
  }

  .profile2InfoMenuItem path {
    fill:var(--icon);
  }

  .profile2InfoMenuItem > svg {
    width:4rem;
    height:4rem;
  }

  .profile2InfoMenuItem > span {
    color:var(--basic);
    font-size:1.3rem;
    font-weight:bold;
    text-align: center;
    margin-top:0.7rem;
    word-break: break-all;
    display:inline-block;
    height:3.5rem;
    display: -webkit-box; /* 创建弹性盒子布局 */
    -webkit-box-orient: vertical; /* 设置盒子为垂直排列 */
    -webkit-line-clamp: 2; /* 限制为显示两行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
  }

  .profile2InfoMenuItem{
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background:var(--primary);
    width:calc((100% - 3.2rem) / 5);
    box-sizing:border-box;
    padding:1rem 1rem;
    border-radius:0.5rem;
  }

  .profile2InfoMenu{
    display:flex;
    justify-content: space-between;
    width:100%;
    /* padding:1.5rem; */
    margin-top:1rem;
  }

  .profile2InfoBoxTopRightRightButton{
    background:var(--gdient2);
    border-radius:0.5rem;
    color:#fff;
    font-weight:bold;
    box-sizing:border-box;
    height:3rem;
    padding:0 1rem;
    display:flex;
    align-items: center;
    justify-content: center;
    font-size:1.1rem;
    margin-right:1rem;
  }

  .profile2InfoBoxTopRightRight{
    display:flex;
    align-items: center;
  }
  .profile2InfoBoxTopRight svg path{
    fill:var(--subfont);
  }

  .profile2InfoBoxTopRight svg {
    width:1.5rem;
    height:1.5rem;
  }

  .profile2InfoBoxTopRight > img {
    height:2.5rem;
    margin-right:2.5rem;
  }

  .profile2InfoBoxTopRight{
    display:flex;
    align-items: center;
  }

  .profile2InfoBoxTopLeft path {
    fill:var(--success);
  }

  .profile2InfoBoxTopLeft > div:nth-child(2){
    margin-top:0.3rem;
  }

  .profile2InfoBoxTopLeft{
    display:flex;
    flex-direction: column;
    color:var(--basic);
    font-size:1.5rem;
    font-weight:bold;
  }

  .profile2InfoBoxTop{
    display:flex;
    justify-content:space-between;
    box-sizing:border-box;
    padding-bottom:1rem;
    border-bottom:0.05rem solid var(--background);
  }

  .profile2InfoBox{
    width:100%;
    background:var(--primary);
    border-radius:0.5rem;
    box-sizing:border-box;
    padding:1.5rem;
    margin-top:1rem;
  }

  .profile2HeaderItem path{
    fill:#fff;
  }
  .profile2HeaderItem > svg {
    height:4rem;
    width:4rem;
  }

  .profile2HeaderItem > span {
    margin-top:0.2rem;
    font-size:1.3rem;
    font-weight:bold;
    color:#fff;
    text-align: center;
    width:6rem;
    display:inline-block;
    word-break: break-all;
    display: -webkit-box; /* 创建弹性盒子布局 */
    -webkit-box-orient: vertical; /* 设置盒子为垂直排列 */
    -webkit-line-clamp: 2; /* 限制为显示两行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
  }

  .profile2HeaderItem{
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .profile2Header{
    background:var(--gdient2);
    width:100%;
    border-radius:0.5rem;
    box-sizing:border-box;
    padding:3rem 1.5rem;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }


  .headPic {
    width: 100%;
    height: 100%;
  }
  .profilePicture {
    height: 8rem;
    width: 8rem;
    position: relative;
  }

  .levelText {
    color:#fda212;
    font-size: 1.2rem;
    font-weight: bold;
    transform:rotate(-90deg);
  }
  .level1 {
    width: 100%;
    position: absolute;
    left: 0rem;
    top: 0rem;
    transform: scale(1.03);
  }

  .levelTextBox{
    position:absolute;
    bottom:-0.5rem;
    right:-0.5rem;
    width: 4rem;
    height: 3.8rem;
    background-repeat:no-repeat;
    background-size:100% 100%;
    display:flex;
    align-items: center;
    justify-content: center;
    transform: rotate(90deg);
  }

  .activeRight > svg {
    width:1.5rem;
    height:1.5rem;
  }

  .activeRight {
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    background: var(--success);
    border-radius: 50%;
    bottom: 0rem;
    right: 0rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .activeDesign {
    position: absolute;
    border: 2px solid var(--success);
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    box-sizing:border-box;
  }

  .entryButton {
    margin-top: 3rem;
    width: 100%;
    height: 5rem;
    background: var(--success);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.8rem;
    border-radius: 1rem;
  }

  .avatarItem img {
    height: 100%;
    width: 100%;
  }
  .avatarItem:nth-child(4n) {
    margin-right: 0 !important;
  }
  .avatarItem {
    height: 8rem;
    width: 8rem;
    margin-right: 1.3rem;
    margin-bottom: 1.5rem;
    position: relative;
  }
  .avatarList {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem;
  }

  .avatarBox {
    display: flex;
    flex-direction: column;
  }

  .box {
    background: var(--background);
    box-sizing: border-box;
    box-sizing: border-box;
    padding: 1rem 1rem;
    padding-bottom: 14rem;
  }
</style>
